import type * as lazyIndex from "./lazyIndex";
import { LazyModule, LazyImport } from "owa-bundling";

export type { InboxRuleStarterContext } from "./store/schema/InboxRuleStarterContext";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "InboxRule" */ "./lazyIndex"), {
    name: "InboxRule",
});

export { lazyOpenInboxRulesSettings, lazyPrepareInboxRuleStarterContext, lazyOpenInboxRuleStarter, } from "./inboxRuleStarters";

export const lazyCreateRuleFromItem: LazyImport<typeof lazyIndex.createRuleFromItem, typeof lazyModule> = new LazyImport(lazyModule, m => m.createRuleFromItem);
export const lazyCreateRuleFromRow: LazyImport<typeof lazyIndex.createRuleFromRow, typeof lazyModule> = new LazyImport(lazyModule, m => m.createRuleFromRow);
